import { useEffect } from 'react';
import JsonLd from '@/components/base/JsonLd';
import { faqs } from '@/mocks/faq';
import Hero from './components/Hero';
import StoryIntro from './components/StoryIntro';
import FeaturedCharacters from './components/FeaturedCharacters';
import CharaShowcase from './components/CharaShowcase';
import VoiceActorSection from './components/VoiceActorSection';
import FaqSection from './components/FaqSection';
import CtaBanner from './components/CtaBanner';

const siteUrl = 'https://starvoice3.github.io';

export default function Home() {
  useEffect(() => {
    document.title = '守护甜心动漫角色大全+声优表｜主要角色与配音演员全收录';
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute(
        'content',
        '守护甜心动漫角色大全页，日奈森亚梦、月咏几斗、边里唯世等主要角色资料一次集齐，同时附守护甜心动漫声优表与配音演员对应信息。想查角色背景故事或确认幕后配音阵容，点开这里直接对号入座。'
      );
  }, []);

  const schema = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '守护甜心档案',
      url: siteUrl,
      description: '守护甜心动漫角色大全与声优表资料站',
      inLanguage: 'zh-CN',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '守护甜心档案',
      url: siteUrl,
      logo: `${siteUrl}/favicon.svg`,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((f) => ({
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a },
      })),
    },
  ];

  return (
    <>
      <JsonLd data={schema} />
      <Hero />
      <StoryIntro />
      <FeaturedCharacters />
      <CharaShowcase />
      <VoiceActorSection />
      <FaqSection />
      <CtaBanner />
    </>
  );
}